import React, { useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import ReactToPrint from 'react-to-print';

import { useRecoilValue } from 'recoil';

import PrintView from 'components/Patient/quote/components/PrintView';
import InvoiceReadOnly from 'components/Payments/components/InvoiceReadOnly';
import { currentPractice } from 'components/practice/practiceState';
import Button from 'components/shared/Buttons/Button';
import Modal from 'components/shared/Modal/Modal';

const QuotePreview = ({ item: quote, isOpen, handleClose }) => {
  const ref = useRef();

  const { patient } = useOutletContext();
  const practice = useRecoilValue(currentPractice);

  return (
    <Modal
      slideFromRight
      isOpen={isOpen}
      handleClose={handleClose}
      bodyClassName="!p-0"
      title="Preview Quote"
      className="!w-[800px] bg-white"
      headButton={
        <div className="flex w-full items-center justify-end">
          <ReactToPrint
            trigger={() => (
              <Button
                size="small"
                type="link"
                text="Print"
                icon="printer-mono"
                className="text-primary-900"
              />
            )}
            content={() => ref.current}
          />
        </div>
      }>
      <div ref={ref}>
        <PrintView
          patient={patient}
          practice={practice}
          createdAt={quote?.created_at}
          content={<InvoiceReadOnly invoices={[quote]} />}
        />
      </div>
    </Modal>
  );
};

export default QuotePreview;
